import NettoLogo from './img/netto.png';
import Coop365Logo from './img/365.png';
import BilkaLogo from './img/bilka.png';
import DagliBrugsenLogo from './img/daglibrugsen.png';
import FøtexLogo from './img/føtex.png';
import KvicklyLogo from './img/kvickly.png';
import LidlLogo from './img/lidl.png';
import MenyLogo from './img/meny.png';
import MinKøbmandLogo from './img/minkøbmand.png';
import RemaLogo from './img/rema1000.jpg';
import SparLogo from './img/spar.png';
import SuperBrugsenLogo from './img/superbrugsen.png';




const Stores = {
    Netto: {
        name: "Netto",
        logo: NettoLogo,
        selected: false,
    },
    Bilka: {
        name: "Bilka",
        logo: BilkaLogo,
        selected: false,
    },
    SuperBrugsen: {
        name: "SuperBrugsen",
        logo: SuperBrugsenLogo,
        selected: false,
    },

    DagliBrugsen: {
        name: "Dagli'Brugsen",
        logo: DagliBrugsenLogo,
        selected: false,

    },
    Føtex: {
        name: "Føtex",
        logo: FøtexLogo,
        selected: false,

    },
    Kvickly: {
        name: "Kvickly",
        logo: KvicklyLogo,
        selected: false,

    },
    Lidl: {
        name: "Lidl",
        logo: LidlLogo,
        selected: false,

    },
    Meny: {
        name: "MENY",
        logo: MenyLogo,
        selected: false,

    },
    MinKøbmand: {
        name: "Min Købmand",
        logo: MinKøbmandLogo,
        selected: false,

    },
    Rema1000: {
        name: "REMA1000",
        logo: RemaLogo,
        selected: false,

    },
    Spar: {
        name: "SPAR",
        logo: SparLogo,
        selected: false,

    },    
    Coop365: {
        name: "Coop 365",
        logo: Coop365Logo,
        selected: false,

    },


}

export default Stores;
